/**
 * 连接到视频会议管理系统的websocket
 */
import websocket from '@/api/websocket.js'
import store from '@/store'

window.cws = null

/**
 * 创建链接
 * @param url
 * @param callback
 */
const connectVCS = (url,callback)=>{
  const key = store.state.user.videoSystemKey

  // 先关闭旧的WebSocket连接，防止连接泄漏
  if (window.cws) {
    try {
      window.cws.close()
      delete window.cws
      window.cws = null
    } catch (e) {
      console.error('close old conference websocket error:', e)
    }
  }

  const ws = new websocket({
    url: url,
    reconnectTimes: null,
    reconnectTime: 60000,
    heartMsg:{method:'ping',key:key},
    _init_func:(event)=>{
      callback ? callback() : null
    }
  })
  window.cws = ws
  return ws
}

/**
 * 销毁连接
 * @param callback
 */
const dispose = (callback) => {
  let ws = window.cws
  if (window.cws) {
    window.cws.close()
    delete window.cws
    window.cws = null
  }
  callback ? callback(ws) : null
}

/**
 * 发送消息
 * @param message
 */
const sendMessage = (message) => {
  //统一添加上Key
  message.key = store.state.user.videoSystemKey
  if (window.cws) {
    window.cws.send(message)
  } else {
    console.log('video conference websocket not connected!')
  }
}

/**
 * 加入会议室
 * @param roomName
 * @param roomNo
 * @param userName
 * @param type
 * @param address
 */
const joinConference = (roomName, roomNo, userName, type, address) => {
  const limit = store.state.user.videoConf
  let message = {}
  message.method = 'joinRoom'
  message.memberType = type
  message.roomName = roomName
  message.userName = userName
  message.roomLimit = limit
  message.roomNum = roomNo
  message.mediaAddress = address
  sendMessage(message)
}

/**
 * 发送邀请
 * @param name
 * @param sdp
 * @param screen
 */
const receive = (name, sdp, screen) => {
  let message = {method: 'receiveVideoFrom', sender: name, sdpOffer: sdp, screen: screen}
  sendMessage(message)
};

/**
 * 自身离开会议室
 */
const leaveRoom = () =>{
  let message = {method:'leaveRoom'}
  sendMessage(message)
}

/**
 * 关闭会议室
 * @param roomName
 * @param roomNum
 */
const closeRoom = (roomName, roomNum) => {
  let message = {method:'closeRoom',roomName:roomName,roomNum:roomNum}
  sendMessage(message)
}

/**
 * 踢出会议室
 * @param roomName
 * @param roomNum
 * @param userName
 */
const kick = (roomName, roomNum, userName) => {
  let message = {method:'kickRoom',userName:userName,roomName:roomName,roomNum:roomNum}
  sendMessage(message)
}

/**
 * 冰候选协商
 * @param candidate
 * @param userName
 * @param screen
 */
const iceCandidate = (candidate, userName, screen) => {
  let message = {method: 'onIceCandidate', candidate: candidate, userName: userName, screen: screen}
  sendMessage(message)
};

/**
 * 开始录像
 * @param roomName
 * @param roomNum
 */
const startRecord = (roomName, roomNum) => {
  let message = {method:'startRecord',roomName:roomName,roomNum:roomNum}
  sendMessage(message)
}

/**
 * 停止录像
 * @param roomName
 * @param roomNum
 */
const stopRecord = (roomName, roomNum) => {
  let message = {method:'stopRecord',roomName:roomName,roomNum:roomNum}
  sendMessage(message)
}

/**
 * 静音
 * @param roomName
 * @param roomNum
 * @param userName
 */
const mute = (roomName, roomNum, userName) => {
  let message = {method:'mute',roomName:roomName,roomNum:roomNum, userName: userName}
  sendMessage(message)
}

/**
 * 取消静音
 * @param roomName
 * @param roomNum
 * @param userName
 */
const unMute = (roomName, roomNum, userName) => {
  let message = {method:'unMute',roomName:roomName,roomNum:roomNum, userName: userName}
  sendMessage(message)
}

/**
 * 禁用自身摄像头
 */
const muteVideo = () => {
  let message = {method:'muteVideo'}
  sendMessage(message)
}

const unMuteVideo = () => {
  let message = {method:'unMuteVideo'}
  sendMessage(message)
}

/**
 * 全静音
 * @param roomName
 * @param roomNum
 */
const muteAll = (roomName, roomNum) => {
  let message = {method:'muteAll',roomName:roomName, roomNum: roomNum}
  sendMessage(message)
}

/**
 * 取消全静音
 * @param roomName
 * @param roomNum
 */
const unMuteAll = (roomName, roomNum) => {
  let message = {method:'unMuteAll',roomName:roomName, roomNum: roomNum}
  sendMessage(message)
}

/**
 * 会议室已存在成员总数
 * @param roomName
 * @param roomNum
 */
const roomParticipantsNumber = (roomName,roomNum)=>{
  let message = {method:'participantNumber',roomName:roomName, roomNum: roomNum}
  sendMessage(message)
}

/**
 * 会议室已存在成员
 * @param roomName
 * @param roomNum
 */
const roomParticipants = (roomName,roomNum)=>{
  let message = {method:'meetingParticipants',roomName:roomName, roomNum: roomNum}
  sendMessage(message)
}

/**
 * 获取当前视频会议系统的信息
 */
const roomInfo = ()=>{
  let message = {method:'roomInfo'}
  sendMessage(message)
}

/**
 * 开始屏幕共享
 * @param roomName
 * @param roomNum
 * @param userName
 */
const startShareScreen = (roomName,roomNum,userName)=>{
  let message = {method:'startShareScreen',roomName:roomName,roomNum:roomNum, userName: userName}
  sendMessage(message)
}

/**
 * 结束屏幕共享
 * @param roomName
 * @param roomNum
 * @param userName
 */
const stopShareScreen = (roomName, roomNum, userName) => {
  let message = {method:'stopShareScreen',roomName:roomName,roomNum:roomNum, userName: userName}
  sendMessage(message)
};

/**
 * 查询广播的成员名称
 * @param roomName
 * @param roomNum
 */
const queryBroadcast = (roomName,roomNum)=>{
  let message = {method:'queryBroadcast',roomName:roomName, roomNum: roomNum};
  sendMessage(message)
}

/**
 * 广播成员画面
 * @param roomName
 * @param roomNum
 * @param names
 */
const broadcast = (roomName, roomNum, names) => {
  let message = {method:'broadcast',roomName:roomName, roomNum: roomNum, pushNames: names}
  sendMessage(message)
};


export {connectVCS,dispose,joinConference,receive,
  leaveRoom,closeRoom,kick,iceCandidate,startRecord,
  stopRecord,mute,unMute,muteAll,unMuteAll,
  roomParticipants,roomParticipantsNumber,roomInfo,muteVideo,unMuteVideo,startShareScreen,stopShareScreen,queryBroadcast,broadcast}



// WEBPACK FOOTER //
// ./src/view/conference/conference-websocket.js